import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import reduxThunk from 'redux-thunk'
import reducers from './reducers'

const logger = createLogger({
  collapsed: true
});

const store = applyMiddleware(reduxThunk, logger)(createStore);

export default store(reducers);



// WEBPACK FOOTER //
// ./src/store/index.js